// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import connectActions from 'utils/connectActions'

// Actions
import { emailVerify } from 'actions/actions'

// Atoms
import { AppProgressActivator } from 'atoms/AppProgress'
import ErrorCard from 'atoms/ErrorCard'
import ContentLoader from 'atoms/ContentLoader'

const mapActionsToProps = {
  emailVerifyAction: emailVerify
}

export default
@connectActions(mapActionsToProps)
@withRouter
class EmailVerifyAction extends Component {
  static propTypes = {
    emailVerifyAction: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    token: PropTypes.string,
  }

  async componentDidMount() {
    const { emailVerifyAction, token, history } = this.props
    try {
      await emailVerifyAction.run({
        params: [token],
        updateComponentOnSuccess: false,
      })
      history.replace({
        pathname: '/build',
        state: { emailJustVerified: true }
      })
    } catch (error) {
      // do nothing
    }
  }

  render() {
    const { emailVerifyAction } = this.props
    return emailVerifyAction.isFailed ? (
      <ErrorCard
        primary="Email verification error"
        secondary={emailVerifyAction.error.message}
        withHomeAction
      />
    ) : (
      <Fragment>
        <AppProgressActivator />
        <ContentLoader centered />
      </Fragment>
    )
  }
}
